export default __webpack_public_path__ + "static/media/suprita-sinha.534204a4.jpeg";